
import { defineComponent } from "vue";
import { TutorialRustdeskServices } from "./tutorial-rustdesk.service";
import { ToastFactory } from "./../../utils/ToastFactory";

const tutorialRustdeskService = new TutorialRustdeskServices();

export default defineComponent({
    name: "tutorialRustDesk",
    data() {
        return {
            userInfo: {} as any,
            idSchedule: this.$route.params.id,
            credentials: {
                userLocalId: " ---" as any,
                userRustDesk: " ---" as any,
                passwordRustDesk: " ---" as any,
                userMac: " ---" as any,
                passwordMac: " ---" as any,
                complete: false as boolean,
            } as any,
            userDate: {
                start: "",
                end: "",
                completeDate: "",
            } as any,
            canUseRustDesk: true as boolean,
            texts: {
                firstPoint: this.$t("tutorialRustDesk.first.firstPoint"),
                subtitle: this.$t("tutorialRustDesk.credentials.subtitle"),
                attention: this.$t("tutorialRustDesk.credentials.attention"),
            },
            showModalConfigRustDesk: false,
            showModalInializationRustDesk: false,
            screenShots: [
                { id: 1, description: this.$t('tutorialRustDesk.config.firstStep'), path: 'first-step-rust-desk-config.png' },
                { id: 2, description: this.$t('tutorialRustDesk.config.secondStep'), path: 'second-step-rust-desk-config.png' },
                { id: 3, description: this.$t('tutorialRustDesk.config.thirdStep'), path: 'third-step-rust-desk-config.png' }
            ],
            screenShotsInialization: [
                { id: 1, description: this.$t('tutorialRustDesk.credentials.inialization.firstStep'), path: 'first-step-rust-desk-initialization.png' },
                { id: 2, description: this.$t('tutorialRustDesk.credentials.inialization.secondStep'), path: 'second-step-rust-desk-initialization.png' },
                { id: 3, description: this.$t('tutorialRustDesk.credentials.inialization.thirdStep'), path: 'third-step-rust-desk-initialization.png' }
            ]
        };
    },


    methods: {
        getScheduleUser(): any {
            tutorialRustdeskService
                .getScheduleUserById(this.idSchedule)
                .then((response) => {
                    this.credentials.userLocalId = response.alias
                    this.credentials.userRustDesk = response.rustDeskId;
                    this.credentials.passwordRustDesk = response.apiPassword;
                    this.credentials.userMac = response.macUser;
                    this.credentials.passwordMac = response.computerPassword;
                    this.credentials.complete = true;
                    this.userDate.start = `${response.initDate} ${response.calendarList[0].checkIn}`;
                    this.userDate.end = `${response.finishDate} ${response.calendarList[0].checkOut}`;
                    this.userDate.completeDate = `${this.formatNextDate(
                        response.initDate
                    )} ${response.calendarList[0].checkIn}-${response.calendarList[0].checkOut
                        }`;
                });
        },
        verifyDateNow(): boolean {
            const now = new Date();
            const startDate = new Date(this.userDate.start);
            const endDate = new Date(this.userDate.end);
            if (startDate <= now && now <= endDate) {
                this.canUseRustDesk = true;
            } else {
                this.canUseRustDesk = false;
            }
            return this.canUseRustDesk;
        },
        openRustDeskError(): void {
            if (!this.idSchedule) {
                this.$toast.add(
                    ToastFactory.error(
                        `${this.$t("toast.errorRustDeskNoSchedule")} ${this.userDate.completeDate
                        }`
                    )
                );
            } else if (this.idSchedule && !this.verifyDateNow()) {
                this.$toast.add(
                    ToastFactory.error(
                        `${this.$t("toast.errorRustDesk")} ${this.userDate.completeDate} `
                    )
                );
            } else {
                window.location.href = `rustdesk://${this.credentials.userRustDesk}`;
            }
        },
        formatNextDate(date: string): string {
            const [year, month, day] = date.split("-");
            const formattedDate = `${day}/${month}/${year}`;
            return formattedDate;
        },
        copyText(text: string): void {
            const textArea = document.createElement("textarea");
            textArea.value = text;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand("copy");
            this.$toast.add(ToastFactory.success("Copiado!"));
            document.body.removeChild(textArea);
        },
        openInstallRustDeskForWindows(): void {
            window.open(process.env.VUE_APP_WINDOWS_DOWNLOAD_RUST_APP_LINK, "_blank");
        },
        openInstallRustDeskForLinux(): void {
            window.open(process.env.VUE_APP_LINUX_DOWNLOAD_RUST_APP_LINK, "_blank");
        },
        showModalForConfigRustDesk(): void {
            this.showModalConfigRustDesk = true;
        },
        showModalForInitializeRustDesk(): void {
            this.showModalInializationRustDesk = true;
        }
    },
    mounted() {
        if (this.idSchedule) {
            this.getScheduleUser();
        } else {
            this.canUseRustDesk = false;
        }
    },
});
